// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2SouV","content":"Consent_content__gtUBS","footer":"Consent_footer__IkrF_"};